import { createFileRoute } from '@tanstack/react-router';

import { getAbstractOptions } from '@/module/Author/Abstract';

export const Route = createFileRoute('/_auth/author/_author/abstract/_abstract/$abstractId/_layout')({
  loader: async ({ params: { abstractId }, context: { queryClient } }) => {
    const abstract = await queryClient.ensureQueryData(getAbstractOptions(abstractId));

    return {
      abstract,
      crumb: abstract.title,
    };
  },
});
